import React from 'react';
import { ConfigProvider } from 'antd';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { useThemeConfig } from 'hooks/useThemeConfig';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { antdTheme, styledTheme } = useThemeConfig();

  return (
    <ConfigProvider theme={antdTheme}>
      <StyledThemeProvider theme={styledTheme}>{children}</StyledThemeProvider>
    </ConfigProvider>
  );
};
